import React from 'react'

import Filters from './Filters'
import Participants from './Participants'
import { Container } from './styles'

const Index = () => {
    return (
        <Container>
            <Filters />
            <Participants />
        </Container>
    )
}

export default Index
